export function PersonalDataConsent({ onOpenPrivacyPolicy, consentId = "pd-consent" }) {
  return (
    <div className="personalDataConsent">
      <label className="field field--inline personalDataConsent__check" htmlFor={consentId}>
        <input id={consentId} name={consentId} type="checkbox" required />
        <span>Я согласен с обработкой персональных данных</span>
      </label>
      <p className="personalDataConsent__doc">
        <button type="button" className="textLinkButton" onClick={onOpenPrivacyPolicy}>
          Политика конфиденциальности
        </button>
      </p>
    </div>
  );
}
